import { render, staticRenderFns } from "./Switchers.vue?vue&type=template&id=301e3c89&scoped=true&"
import script from "./Switchers.vue?vue&type=script&lang=ts&"
export * from "./Switchers.vue?vue&type=script&lang=ts&"
import style0 from "./Switchers.vue?vue&type=style&index=0&id=301e3c89&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "301e3c89",
  null
  
)

export default component.exports